export default [
  {
    "type": "PrivacyManager",
    "name": "Privacy Manager",
    "settings": {},
    "children": []
  },
  {
    "type": "CustomPmView",
    "name": "Custom View",
    "settings": {},
    "children": []
  }
];